import { Component, OnDestroy, OnInit } from '@angular/core';
import { convertDesignIdToCommunicationId, trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService, TechnicalReviewService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-technical-review',
  templateUrl: './technical-review.component.html',
  standalone: false,
})
export class TechnicalReviewComponent implements OnInit, OnDestroy {
  public readonly designLoading$ = this.designService.loading$;
  public readonly technicalReviewDocuments$ = this.technicalReviewDocumentService.technicalReviews$;
  public readonly technicalReviewLoading$ = this.technicalReviewDocumentService.loading$;
  public readonly error$ = this.technicalReviewDocumentService.error$;
  public readonly trackByRef = trackByRef;
  public siteUrl = environment.sharePointTRSiteUrl;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly technicalReviewDocumentService: TechnicalReviewService,
    private readonly designService: DesignService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(
          map(convertDesignIdToCommunicationId),
          switchMap((communicationId) =>
            this.technicalReviewDocumentService.loadByCommunicationId(communicationId)
          )
        )
        .subscribe()
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
